module.exports = __webpack_public_path__ + "img/07.97557fc9.jpg";